import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCommentIconHover = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#d04237"
      d="M18.75 0H1.25C.558 0 0 .56 0 1.25V20l5-5h13.75c.69 0 1.25-.56 1.25-1.25V1.25C20 .56 19.44 0 18.75 0ZM6.25 8.75a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm3.75 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm3.75 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z"
    />
  </svg>
);
export default SvgCommentIconHover;
